module.exports = __webpack_public_path__ + "img/prim-close.a6e1b4e2.svg";